const CEOMessage = () => {
    return (
        <div className="flex w-screen items-center justify-between sm:flex-row pt-7 sm:pb-7 flex-col">
            <div
                className="sm:w-[50vw] w-[80vw] flex items-center justify-center"
            >
                <img src="/CEO with Rectangle.png" alt="CEO with Rectangle" className="w-[100%]" />
            </div>
            <div className="flex flex-col sm:pl-10 sm:pr-14 sm:w-[50vw] sm:px-2 items-center gap-y-12 mb-10 sm:mb-0 px-10">
                <div className="w-fit flex items-center flex-col">
                    <div className="font-poppins font-extralight text-4xl text-center text-primary-blue mb-6 sm:mt-0 mt-10">
                        CEO's Message
                    </div>
                    <div className="font-poppins text-lg font-extralight text-center mt-1">
                        We extend a warm welcome to all our members, investors,
                        and business partners!
                        <br />
                        <br />
                        As a leading name in Pakistan’s real estate, Sultana
                        Group celebrates two generations of expertise and
                        exceptional service.
                        <br />
                        <br />
                        Our global entrepreneurial spirit and professional
                        excellence have led to premium residential and
                        commercial developments in Lahore with the help of our
                        exceptional team.
                        <br />
                        <br />
                        We’re excited for future growth and investment
                        opportunities, aiming to enhance community value and
                        contribute to our nation’s economy.
                        <br />
                        <br />
                        Thank you for your trust in Sultana Group.
                    </div>
                    <img
                        src="/Signature.png"
                        alt="signature"
                        style={{ width: "150px" }}
                        className="mt-10"
                    />
                    <div className="font-poppins text-lg text-primary-gold mt-5">
                        Murad Sharif
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CEOMessage;
